export enum VariantOptions {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}

export type Variant = 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info';
